export default {
    methods: {
        iniciarSesion(data) {
            this.$store.commit('setLoading', true);
            this.$http.post(`${this.$apiUrl}/api/authorize`,
                data).then(response => {
                    this.$Progress.finish();
                    const token = response.data.access_token;
                    const modulos = response.data.modulos;
                    this.$storage.set("code", token);
                    this.$store.commit('setToken', token)
                    this.$storage.set("modulos", modulos);
                    this.$store.commit('setModulos', modulos)
                    this.$storage.set("token", response.data.refresh_token);
                    this.$store.commit('setRefreshToken', response.data.refresh_token)
                    this.$storage.set("user", response.data.usuario);
                    this.$store.commit('setUser', response.data.usuario)
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', null)
                    if (modulos.length === 1) {
                        var modulosHijos = modulos[0].modulosHijos
                        if (modulosHijos.length === 1) {
                            this.$router.push({ name: 'RedirectModule', params: { id: modulosHijos[0].id } })
                        } else {
                            this.$router.push('/inicio')
                        }
                    } else {
                        this.$router.push('/inicio')
                    }
                }).catch((error) => {
                    this.$store.commit('setLoading', false);
                    this.$Progress.finish();
                    this.$store.commit('setError', 'La combinacion del Usuario y la Contraseña son Incorrectas')
                });
        },
        cerrarSesion() {
            this.$Progress.start();
            this.$store.commit('setMensajeApp', 'Cerrando session, espere un momnento ...')
            this.$store.commit('setLoadingApp', true)
            this.$http.post(`${this.$apiUrl}/api/cerrarSesion`,
                { token: this.$store.state.token }, {
                    headers: {
                        "content-Type": 'application/json'
                    }
                }).then(response => {
                    this.$Progress.finish();
                    this.$store.commit('setLoadingApp', false)
                   this.$store.commit('setLoading', false);
                    this.$store.commit('setUser', null);
                    this.$store.commit('setToken', null);
                    this.$store.commit('setModulos', null);
                    this.$store.commit('setRefreshToken', null);
                    localStorage.clear();
                    window.location.replace(response.data.data.urlLogout);
                }).catch(error => {
                    console.log(error)
                    this.$Progress.fail();
                    this.$store.commit('setError', 'Algo Salio mal :' + error.response)
                    this.$router.push('/inicio')
                })
                
        }
    }
}